/* RESPONSIBLE TEAM: team-standalone */

import { ChannelTargetingBodyData } from '../definitions';

export default class GenericChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.generic';
  }

  get channels(): ChannelTargetingBodyData['channels'] {
    return [];
  }
}
